import { render } from "./MonitorCustomEventAlert.vue?vue&type=template&id=66496400"
import script from "./MonitorCustomEventAlert.vue?vue&type=script&lang=js"
export * from "./MonitorCustomEventAlert.vue?vue&type=script&lang=js"
script.render = render

export default script